import { useState } from 'react';
import { useKpiPointProgress } from '../../../hooks/useKpiPointProgress.js';
import {
  PointProgressChart,
  getDefaultPointProgressPeriod,
  parsePointProgressPeriod,
} from './PointProgressChart.js';
import type { KpiTeam } from '../../../types/api.js';

interface PointProgressSectionProps {
  /** 親のチームフィルタ。粒度（PDG/ACE → チーム → メンバー）と内訳ラベル解決に使用 */
  team: KpiTeam;
}

/**
 * pt進捗比較セクション。期間（月/FY四半期）状態とデータ取得を内包し、
 * PointProgressChart を描画するコンテナコンポーネント
 *
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business pt進捗比較セクションのコンテナ。セクション個別の期間フィルタ状態を保持し、
 *  team + 期間で pt進捗比較データを取得してチャートカードを表示
 * @graph-connects useKpiPointProgress [calls] pt進捗比較データ取得
 * @graph-connects PointProgressChart [calls] pt進捗比較チャートカード描画
 * @graph-connects getDefaultPointProgressPeriod [calls] デフォルト期間（当月）生成
 * @graph-connects parsePointProgressPeriod [calls] 期間 Select 値の API パラメータ変換
 */
export function PointProgressSection({ team }: PointProgressSectionProps) {
  // pt進捗比較セクションの期間（'month:YYYY-MM' / 'quarter:YYYY-Qn'）。デフォルトは当月
  const [selectedPeriod, setSelectedPeriod] = useState(getDefaultPointProgressPeriod);
  const { periodType, period } = parsePointProgressPeriod(selectedPeriod);
  const { data, isLoading } = useKpiPointProgress({ team, periodType, period });

  return (
    <PointProgressChart
      data={data}
      isLoading={isLoading}
      selectedPeriod={selectedPeriod}
      onPeriodChange={setSelectedPeriod}
      team={team}
    />
  );
}
